var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6788 0.671143C14.4565 0.671143 14.2626 0.7429 14.1003 0.885037L8.0016 6.68507L1.90289 0.885037C1.73895 0.7429 1.54666 0.671143 1.3244 0.671143C1.10214 0.671143 0.909846 0.7429 0.745911 0.885037C0.581977 1.02855 0.5 1.20381 0.5 1.40667C0.5 1.60952 0.5804 1.79582 0.745911 1.95866L7.44043 8.27894C7.58072 8.42246 7.76673 8.49422 8.00002 8.49422C8.23331 8.49422 8.42086 8.42246 8.56115 8.27894L15.2557 1.95866C15.418 1.79582 15.5 1.6109 15.5 1.40667C15.5 1.20243 15.418 1.02855 15.2557 0.885037C15.0917 0.7429 14.8994 0.671143 14.6772 0.671143H14.6788Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.2e3d06550cf405a24b89b4aabb9b0125.svg";
export { ForwardRef as ReactComponent };